import { Box, Flex, Text, Tooltip, type TooltipProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ImpersonationBannerOverridesTooltipProps {
  content: ReactNode;
  hasOverrides: boolean;
  label: string;
  value: string;
  maxWidth: TooltipProps['maxWidth'];
  tooltipMaxWidth?: TooltipProps['maxWidth'];
}

export function ImpersonationBannerOverridesTooltip({
  content,
  hasOverrides,
  label,
  value,
  maxWidth,
  tooltipMaxWidth,
}: ImpersonationBannerOverridesTooltipProps) {
  return (
    <Tooltip
      label={
        <Box px={0.5} py={0.5}>
          {content}
        </Box>
      }
      bg="white"
      color="gray.800"
      borderRadius="md"
      px={3}
      py={2}
      border="1px solid"
      borderColor="gray.200"
      boxShadow="md"
      zIndex={10001}
      maxWidth={tooltipMaxWidth ?? maxWidth}
      hasArrow
    >
      <Flex
        alignItems="center"
        gap={1}
        opacity={hasOverrides ? 1 : 0.6}
        cursor="pointer"
        minW={0}
      >
        {hasOverrides && (
          <Box width="6px" height="6px" borderRadius="full" bg="orange.300" />
        )}
        <Text fontSize="xs" color="white" isTruncated={true} maxW={maxWidth}>
          {label}: {value}
        </Text>
      </Flex>
    </Tooltip>
  );
}
